'use client'

import { URLS } from '@router'
import { assertIos, getFullPath } from '@utils'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export default function Content() {
  const searchParams = useSearchParams()
  useEffect(() => {
    const link = searchParams.get('link')
    const url = new URL(link)
    const isIos = assertIos()

    if (isIos) {
      window.location.href = `oneroof://com.nzme.oneroof${url.pathname}${url.search}`
    } else {
      window.location.href = `app://com.nzme.oneroof${url.pathname}${url.search}`
    }
    // 如果没有跳转到APP，则跳转到下载页面
    const timer = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.location.href = getFullPath(URLS.download)
      }
    }, 3000)
    function clearTimer() {
      clearTimeout(timer)
      window.location.href = link
    }
    window.addEventListener('visibilitychange', clearTimer)

    return () => {
      window.removeEventListener('visibilitychange', clearTimer)
    }

  }, [searchParams])

  return (
    <div>Loading...</div>
  )
}